<template>
	<div class="d-flex-between-center">
		<div class="f-regular f-16 f-c-black">
			Total Tagihan
		</div>
		<div class="f-regular f-16 f-c-black" v-if="!tagihanTambahan">
			{{ transaksi.detail_transaksi.grandtotal | currency }}
		</div>
		<div class="f-regular f-16 f-c-black" v-else>
			{{ transaksi.detail_transaksi.pengantaran_extra.biaya | currency }}
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTagihanTotalTagihan",
	props: {
		transaksi: Object,
		tagihanTambahan: Boolean,
	}
}
</script>